/**
 * Created by JT876ZE on 3/7/2017.
 * @module DatePicker
 * @extends React.Component
 */

import React from 'react';
import styled from 'styled-components';
import DatePicker from '@ey/canvascoreservices/DatePicker';
import Utility from '../../../util/utilityfunctions';

export default function MDatePicker(props) {
	const {
		calendarPlacement,
		className,
		closeText,
		format,
		id,
		isClear,
		isOpen,
		label,
		locale,
		onCalendarClose,
		onChange,
		styleName,
		value,
		disabled,
		placeholder,
		errorMessage,
		showErrorMessage,
		onKeyDown,
		dayPlaceholder,
		monthPlaceholder,
		yearPlaceholder,
		isDuedate,
		oldBehavior = false
	} = props;

	let dateObject = null;
	if (value) {
		if (value._isAMomentObject) {
			dateObject = value.toDate();
		} else if (value instanceof Date || oldBehavior) {
			dateObject = value;
		} else {
			const [day, month, year] = value.split('/').map(Number);
			dateObject = new Date(year, month - 1, day);
		}
	}

	return (
		<Wrapper className={`MotifDatePickerWrapper ${styleName}`}>
			<DatePicker
				calendarPlacement={calendarPlacement}
				className={className}
				closeText={closeText}
				dayPlaceholder={dayPlaceholder}
				format={format}
				id={id}
				isClear={isClear}
				isOpen={isOpen}
				label={label}
				locale={locale}
				monthPlaceholder={monthPlaceholder}
				onCalendarClose={onCalendarClose}
				onChange={onChange}
				styleName={styleName}
				value={dateObject}
				yearPlaceholder={yearPlaceholder}
				disabled={disabled}
				theme={Utility.getTheme()}
				placeholder={placeholder}
				errorMessage={errorMessage}
				showErrorMessage={showErrorMessage}
				showLeadingZeros={false}
				onKeyDown={onKeyDown}
				isDuedate={isDuedate}
			/>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	.motif-form-field {
		width: 100%;
	}
	.datePicker-closeIcon {
		background-color: var(--neutrals-200);
		padding: var(--px-3) var(--px-6);
		font-size: var(--px-14);
		border: var(--px-1) solid var(--neutrals-700);
		display: inline-flex;
		margin-bottom: var(--px-16);
		align-items: center;
	}
`;
